import { useTranslation } from 'react-i18next';
import { MDBFooter } from 'mdb-react-ui-kit';
import styled from 'styled-components';

const StyledFooter = styled(MDBFooter)`
  background-color: var(--main-color);
  color: #D3D3D3;
  text-align: center;
  padding: 1rem 0;

  @media (max-width: 426px) {
    position: fixed;
    bottom: 0;
    width: 100%;
    font-size: 0.8rem;
    padding: 0.5rem;
    min-height: 3rem;
}
`;

export default function Footer() {
  const { t, i18n } = useTranslation();
  const isFrench = i18n.language === 'fr';

  return (
    <StyledFooter>
      <div>
        <a style={{ color: '#D3D3D3' }} href="mailto:support@flagpoletech.ca">support@flagpoletech.ca</a> |{' '}
        <a href='/terms-and-conditions' style={{ color: '#D3D3D3', textDecoration: 'none' }}>{t('footer.terms')}</a>
      </div>
      <div>
        &copy; {new Date().getFullYear()} {isFrench ? 'Technologies Flagpole' : 'Flagpole Technologies'}
      </div>
    </StyledFooter>
  );
}
